import { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import { MdAdd, MdDelete } from "react-icons/md";
import { Link } from "react-router-dom";
import {
  useGetInvoicesQuery,
  useRemoveInvoiceMutation,
} from "../../../features/api/orderinvoiceApi";
import { toast } from "react-toastify";
import { useRemoveSaleslistMutation } from "../../../features/api/saleslistApi";
import { useRemoveTransactionMutation } from "../../../features/api/transactionApi";
import { useGetDealersQuery } from "../../../features/api/dealerApi";
import { formatDate } from "../../../components/CommonDateFormat";

const Orders = () => {
  const { data: dlr } = useGetDealersQuery(null, {
    refetchOnMountOrArgChange: true,
  });
  const dealers = dlr?.dealer;

  const { data, isLoading } = useGetInvoicesQuery(null, {
    refetchOnMountOrArgChange: true,
  });

  const [removeInvoice] = useRemoveInvoiceMutation();
  // const [removeSaleslistItem] = useRemoveSaleslistMutation();
  const [removeSalesListByInv] = useRemoveSaleslistMutation();
  const [removeFromTransaction] = useRemoveTransactionMutation();

  const handleDelete = async (id) => {
    const confirm = window.confirm("Are Your Sure?");
    if (confirm) {
      try {
        const result = await removeInvoice(id);
        console.log(result?.error?.error);
        //  const result2= await removeSaleslistItem(id);
        const result2 = await removeSalesListByInv(id);
        console.log(result2);
        await removeFromTransaction(id);
        if (result) {
          toast.success("Delete Success..!!!");
        }
      } catch (error) {
        console.log(error?.status);
      }
    }
  };

  // Search Term Start
  const [searchTerm, setInputValue] = useState("");
  const searchResults = data?.filter((option) => {
    if (option && typeof option === "object") {
      return Object.values(option).some((value) => {
        if (typeof value === "string") {
          return value.toLowerCase().includes(searchTerm.toLowerCase());
        } else {
          return String(value).toLowerCase().includes(searchTerm.toLowerCase());
        }
      });
    } else {
      return false;
    }
  });
  // Search Term End

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const commaForAmt = (number) => {
    return number ? new Intl.NumberFormat("en-IN").format(number) : 0;
  };

  return (
    <div className="">
      <div className="flex justify-between items-center px-12 py-6">
        <h1 className="text-xl font-bold">Sales & Bill</h1>
        <Link
          to="/dashboard/orders/create"
          className="text-white bg-blue-500 cursor-pointer flex items-center px-3 rounded py-1"
        >
          {" "}
          <span>
            <MdAdd className="text-2xl" />
          </span>
          <span>New Bill</span>
        </Link>
      </div>
      <input
        type="text"
        placeholder="Search Bill"
        className="border ml-12 focus:outline-none h-8 rounded p-1"
        value={searchTerm}
        onChange={(e) => setInputValue(e.target.value)}
      />
      <div className="h-[71vh] overflow-auto w-full m-auto px-12 my-5">
        {isLoading ? (
          <div className="w-fll h-screen flex flex-col items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
        ) : data?.length === 0 ? (
          <p className=" text-xl text-red-500 mt-20 ml-20">
            There are no order Bill
          </p>
        ) : (
          <TableContainer
            component={Paper}
            // style={{ backgroundColor: "#f0f0f5" }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {/* <TableCell>
                    <span className="font-bold">Sl No.</span>
                  </TableCell> */}
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Bill No.</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Bill Date</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Delivery Date</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Client</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Amount</span>
                  </TableCell>
                  {/* <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Bill</span>
                  </TableCell> */}
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Bill</span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {searchResults
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((row, i) => {
                    const dName = dealers?.find(
                      (dlr) => dlr?.id === row?.dealer
                    );
                    const passData = { row, dName };
                    return (
                      <TableRow key={row?.id}>
                        {/* <TableCell>{i + 1}</TableCell> */}
                        <TableCell>{row?.inv_no}</TableCell>
                        <TableCell>{formatDate(row?.inv_date)}</TableCell>
                        <TableCell>{formatDate(row?.d_date)}</TableCell>
                        <TableCell>{row?.customer}</TableCell>
                        <TableCell>{commaForAmt(row?.t_w_d)}</TableCell>
                        {/* <TableCell className="">
                          <div className="flex items-center gap-x-4">
                            <span onClick={() => handleDelete(row?.inv_no)}>
                              <MdDelete className="text-xl text-red-500 font-bold cursor-pointer" />
                            </span>
                          </div>
                        </TableCell> */}
                        {/* <TableCell className="">
                          <div className="flex items-center gap-x-4">
                            <Link
                              to="/dashboard/order/invoice/report"
                              state={passData}
                            >
                              <span className=" underline text-blue-600">
                                Bill
                              </span>
                            </Link>
                          </div>
                        </TableCell> */}
                        <TableCell className="">
                          <div className="flex items-center gap-x-4">
                            <Link to={`/dashboard/order/invoice/${row?.id}`}>
                              <span className=" underline text-blue-600">
                                Bill
                              </span>
                            </Link>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
            <TablePagination
              style={{ backgroundColor: "#f0f0f5" }}
              rowsPerPageOptions={[20, 30, 50]}
              component="div"
              count={data?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default Orders;
